export default __webpack_public_path__ + "static/39-fa416e59cd7eb9b7bac6fdba915573a5.png";